import React from 'react';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import Step8Summary from '../EnrollmentSteps/Step8Summary';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import Step7Card from '../EnrollmentSteps/Step7Card';
import FingerprintStep from '../EnrollmentSteps/FingerprintStep';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import AccessRights from '../AccessRightsSection/AccessRights';
import Step3EmployeeContract from '../EnrollmentSteps/Step3EmployeeContract';
import Step1Details from '../EnrollmentSteps/Step1Details';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import { CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA } from '../Model/Models';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CreateEmployeeWithoutExtraData = (props) => {
    const {
        disabled,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleClearUserData,
        userData,
        handleFormChangeUserData,
        emptyFields,
        isValidEmail,
        isValidDocumentId,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidPin,
        createEmployeeEmail,
        handleValidationStepDetails,
        employeeData,
        employeeRoles,
        employeeWorkStations,
        contractStatusList,
        employeeDepartments,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        handleFormChangeEmployeeData,
        setEmployeeData,
        handleClearEmployeeData,
        isPilgrimsValidation,
        handleValidationContract,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        resetForm,
        photoPickerFile,
        setPhotoPickerFile,
        emptySelfie,
        handleValidationSelfie,
        t,
        capturing,
        setCapturing,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintSrc,
        setFingerprintSrc,
        updatedFinger,
        setFingerprintName,
        setSelectedReader,
        fingerprintsList,
        setUpdated,
        setModified,
        fingerprintName,
        fingerprintsTemp,
        setFingerprintsTemp,
        handleUploadFinger,
        mergedFingerprints,
        setEmptyFields,
        extraData,
        extraDataEnabled,
        selectedImage,
        selfieSrc,
        headersList,
        handleCreateEmployee,
        isValidCecoCode,
        cardsList,
        setCardsList
    } = props;
    return (
        <>
            <div className='mb-60px'>
                <StepperTabs
                    disabled={disabled}
                    id={null}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={() => {}}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.DETAILS}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        <div className='col-12 d-flex justify-content-end mb-2'>
                            <ButtonIcon
                                className='btn-clean-secondary-600'
                                id='btn_cewed_clean'
                                Icon={CleanIcon}
                                title={'clear_instances'}
                                iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                onClick={() => {
                                    handleClearUserData();
                                }}
                            />
                        </div>
                        <Step1Details
                            userData={userData}
                            onChange={handleFormChangeUserData}
                            emptyFields={emptyFields}
                            isValidEmail={isValidEmail}
                            isValidDocumentId={isValidDocumentId}
                            isValidPhoneNumber={isValidPhoneNumber}
                            isValidDob={isValidDob}
                            setIsValidDob={setIsValidDob}
                            isValidPin={isValidPin}
                            createEmployeeEmail={createEmployeeEmail}
                        />
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep
                                id='btn_cewed_next_details'
                                text='next'
                                click={() => {
                                    handleValidationStepDetails();
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.EMPLOYEE_CONTRACT}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        <Step3EmployeeContract
                            employeeData={employeeData}
                            employeeRoles={employeeRoles}
                            employeeWorkStations={employeeWorkStations}
                            contractStatusList={contractStatusList}
                            employeeDepartments={employeeDepartments}
                            emptyFields={emptyFields}
                            isValidStartDate={isValidStartDate}
                            setIsValidStartDate={setIsValidStartDate}
                            isValidEndDate={isValidEndDate}
                            setIsValidEndDate={setIsValidEndDate}
                            onChange={handleFormChangeEmployeeData}
                            setEmployeeData={setEmployeeData}
                            handleClearEmployeeData={handleClearEmployeeData}
                            isPilgrimsValidation={isPilgrimsValidation}
                            isValidCecoCode={isValidCecoCode}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_contract'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_next_contract'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    handleValidationContract();
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.ACCESS_RIGHTS}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        <AccessRights
                            workShiftsList={workShiftsList}
                            setWorkShiftsList={setWorkShiftsList}
                            customizedList={customizedList}
                            setCustomizedList={setCustomizedList}
                            user={userData}
                            isEditable={true}
                            resetForm={() => {
                                resetForm(activeStep);
                            }}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_rights'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_next_rights'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.PHOTO_PROFILE}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        {activeStep === CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.PHOTO_PROFILE && (
                            <CustomPhotoPicker
                                id='fp_cewed_create_photo_profile'
                                photoPicker={photoPickerFile}
                                setPhotoPicker={setPhotoPickerFile}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                showBtnCamera={true}
                                validateFace={true}
                                classWith={'content-center-w-400px'}
                                showPreview={true}
                                disabled={disabled}
                                required={isPilgrimsValidation}
                                emptyFields={emptySelfie}
                                typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                            />
                        )}
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_selfie'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_next_selfie'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    handleValidationSelfie();
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.FINGERPRINT}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        <FingerprintStep
                            t={t}
                            capturing={capturing}
                            setCapturing={setCapturing}
                            capturedFingerprint={capturedFingerprint}
                            setCapturedFingerprint={setCapturedFingerprint}
                            fingerprintSrc={fingerprintSrc}
                            setFingerprintSrc={setFingerprintSrc}
                            updatedFinger={updatedFinger}
                            setFingerprintName={setFingerprintName}
                            setSelectedReader={setSelectedReader}
                            fingerprintsList={fingerprintsList}
                            setUpdated={setUpdated}
                            setModified={setModified}
                            fingerprintName={fingerprintName}
                            handleUploadFinger={handleUploadFinger}
                            userData={userData}
                            fingerprintsTemp={fingerprintsTemp}
                            setFingerprintsTemp={setFingerprintsTemp}
                            mergedFingerprints={mergedFingerprints}
                            emptyFields={emptyFields}
                            setEmptyFields={setEmptyFields}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_finger'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_next_finger'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.CARD}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        {activeStep === CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.CARD && (
                            <Step7Card
                                cardsList={cardsList}
                                setCardsList={setCardsList}
                                componentAction={ACTION_MODEL.CREATE}
                            />
                        )}
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_card'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_next_card'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </StepTab>
                    <StepTab
                        index={CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA.SUMMARY}
                        activeStep={activeStep}
                        normalHeight={true}
                    >
                        <Step8Summary
                            userData={userData}
                            extraData={extraData}
                            employeeRoles={employeeRoles}
                            employeeWorkStations={employeeWorkStations}
                            contractStatusList={contractStatusList}
                            employeeDepartments={employeeDepartments}
                            workShiftsList={workShiftsList}
                            customizedList={customizedList}
                            onChange={handleFormChangeEmployeeData}
                            extraDataEnabled={extraDataEnabled}
                            employeeData={employeeData}
                            selectedImage={selectedImage}
                            selfieSrc={selfieSrc}
                            mergedFingerprints={mergedFingerprints}
                            headersList={headersList}
                            photoPicker={photoPickerFile}
                            isPilgrimsValidation={isPilgrimsValidation}
                            cardsList={cardsList}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep
                                id='btn_cewed_back_summary'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cewed_enroll'
                                text='create'
                                click={() => {
                                    handleCreateEmployee();
                                }}
                            />
                        </div>
                    </StepTab>
                </StepperTabs>
            </div>
        </>
    );
};

export default CreateEmployeeWithoutExtraData;
